export default __webpack_public_path__ + "static/media/tmb.e0e4452a.svg";